import { useAuthStore } from "@/stores/authStore";

/**
 * Simple <select> dropdown for switching between orgs the user belongs to.
 * Phase 1 ships the plumbing; richer invite-management UI lands in Phase 2.
 */
export function OrgSwitcher() {
  const { org, orgs, switchOrg } = useAuthStore();
  if (orgs.length === 0) return null;

  return (
    <label className="flex items-center gap-2 text-xs text-fg-muted">
      <span className="uppercase tracking-wider">Workspace</span>
      <select
        value={org?.id ?? ""}
        onChange={(e) => void switchOrg(e.target.value)}
        className="bg-bg1 border border-border rounded px-2 py-1 text-fg text-xs focus:outline-none focus:border-teal"
      >
        {orgs.map((o) => (
          <option key={o.id} value={o.id}>
            {o.name} · {o.role}
          </option>
        ))}
      </select>
    </label>
  );
}
